import { createWebHistory, createRouter } from "vue-router"
import loginRoutes from "@/modules/login/router/routes"
import homeRoutes from "@/modules/home/router/routes"
import benefitsEnrollmentRoutes from "@/modules/enrollment/router/routes"
import benefitsEnrollmentNewRoutes from "@/modules/enrollment-new/router/routes"
import instructionRoutes from "@/modules/instructions/router/routes"
import careNavigationRoutes from "@/modules/care-navigation/router/routes"
import analyticsService from "@/services/analytics/analytics-service"
import schedulingRoutes from "@/modules/scheduling/router/routes"
import GuardianRunner from "@/router/guardian-runner"

const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...loginRoutes,
    ...homeRoutes,
    ...benefitsEnrollmentRoutes,
    ...benefitsEnrollmentNewRoutes,
    ...instructionRoutes,
    ...careNavigationRoutes,
    ...schedulingRoutes,
    {
      path: "/:pathMatch(.*)*",
      redirect: { name: "login" }
    }
  ],
  scrollBehavior(_, __, ___) {
    return { top: 0 }
  }
})

router.afterEach((to, from) => {
  analyticsService.pageViewed({
    name: to.name,
    path: to.path,
    from_name: from ? from.name : null,
    from_path: from ? from.path : null,
    ...to.query
  })
})

// Set init global route guardian
GuardianRunner.init([])

export default router
